import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadOrderBuilder = create(actions.LOAD_ORDER_BUILDER_DATA);
export const setOrderBuilderStatus = create(actions.SET_ORDER_BUILDER_STATUS);
export const setOrderBuilderData = create(actions.SET_ORDER_BUILDER_DATA);

export const loadPresets = create(actions.LOAD_PRESET_DATA);
export const setPresetStatus = create(actions.SET_PRESET_STATUS);
export const setPresetData = create(actions.SET_PRESET_DATA);

export const loadConfigurationGroup = create(actions.LOAD_CONFIGURATION_GROUP_DATA);
export const setConfigurationGroupStatus = create(actions.SET_CONFIGURATION_GROUP_STATUS);
export const setConfigurationGroupData = create(actions.SET_CONFIGURATION_GROUP_DATA);
export const setConfigurationGroupLeft = create(actions.SET_CONFIGURATION_GROUP_LEFT);
export const setConfigurationGroupRight = create(actions.SET_CONFIGURATION_GROUP_RIGHT);

export const loadCustomOptionsGroup = create(actions.LOAD_CUSTOM_OPTIONS_GROUP_DATA);
export const setCustomOptionsGroupStatus = create(actions.SET_CUSTOM_OPTIONS_GROUP_STATUS);
export const setCustomOptionsGroupData = create(actions.SET_CUSTOM_OPTIONS_GROUP_DATA);
export const setCustomOptionsGroupLeft = create(actions.SET_CUSTOM_OPTIONS_GROUP_LEFT);
export const setCustomOptionsGroupRight = create(actions.SET_CUSTOM_OPTIONS_GROUP_RIGHT);

export const loadCheckboxSettings = create(actions.LOAD_CHECKBOX_SETTINGS_DATA);
export const setCheckboxSettingsStatus = create(actions.SET_CHECKBOX_SETTINGS_STATUS);
export const setCheckboxSettingsData = create(actions.SET_CHECKBOX_SETTINGS_DATA);

export const loadDiscountSelectionSectionSettings = create(actions.LOAD_DISCOUNT_SELECTION_SECTION_SETTINGS);
export const setDiscountSelectionSectionStatus = create(actions.SET_DISCOUNT_SELECTION_SECTION_STATUS);
export const setDiscountSelectionSectionData = create(actions.SET_DISCOUNT_SELECTION_SECTION_DATA);

export const loadPromotions = create(actions.LOAD_PROMOTIONS);
export const setPromotionsStatus = create(actions.SET_PROMOTIONS_STATUS);
export const setPromotionsData = create(actions.SET_PROMOTIONS_DATA);

export const addOrderToCart = create(actions.ADD_ORDER_TO_CART);
export const setCartStatus = create(actions.SET_CART_STATUS);
export const setCartData = create(actions.SET_CART_DATA);

export const getParentCodes = create(actions.LOAD_PARENT_CODES_DATA);
export const setParentCodesStatus = create(actions.SET_PARENT_CODES_STATUS);
export const setParentCodesData = create(actions.SET_PARENT_CODES_DATA);
